import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { DialogRef } from '@angular/cdk/dialog';
import { OrthoCadExportModal, OrthoCadExportModalData } from './orthoCadExport.component';

export interface ExportRequest {
	orderDetailsId: number;
	orderId: number;
}

@Injectable({ providedIn: 'root' })
export class OrthoCadExportService {
	constructor(private readonly modalWindowService: TlkModalWindowService) {}

	openOrthoCadExportModal(caseTypeId: string, request: ExportRequest): DialogRef<void, unknown> {
		const data: OrthoCadExportModalData = {
			caseTypeId: +caseTypeId,
			orderId: request.orderId,
			orderDetailsId: request.orderDetailsId,
		};

		return this.modalWindowService.open<void>(OrthoCadExportModal, {
			width: '480px',
			disableClose: true,
			data,
		});
	}
}
